<template>
	<div>
    <content-data :list="id" editpath="/devices/models/list/" :disable-import="true" :key="id" :search="data_search"></content-data>

    <action-buttons @add="open_add"></action-buttons>

    <BottomSheet :prependExtraTabs="tabs" defaultTab="model_info"></BottomSheet>


  </div>
</template>

<script>
import ContentData from '../content/Data'
import BottomSheet from '../BottomSheet';
import ModelInfo from './editor/ModelInfo'
import ActionButtons from '@/components/ActionButtons.vue'

export default {
	props: ["id"],
	components: {
		ContentData,
    BottomSheet,
    ActionButtons
	},
  data () {
    return {
      tabs: [
        {title: "Model info", name: "model_info", component: ModelInfo},
      ]
    }
  },
  mounted () {
  },
	methods:{
    open_add() {
      this.$router.push("/devices/models/list/" + this.id + "/data/new");
    }
  },
  computed: {
    data_search () {
      return this.$store.state.search_text;
    }
  }
}
</script>